export const actions = {
    FETCH: 'FETCH',
}